// extracted by mini-css-extract-plugin
export default {"sidebar-header":"SidebarHeader_sidebar-header__PxEyC","content":"SidebarHeader_content__bE4XD","filter-icon":"SidebarHeader_filter-icon__12YE8"};